import { UIText3 } from '@cian/ui-kit';
import * as React from 'react';

import * as style from './style.css';

export const ModerationLink: React.FC<{}> = () => {
  return (
    <a
      className={style['link']}
      target="_blank"
      title="Правила модерации"
      href="https://images.cdn-cian.ru/imgmobile/builders/reviews/moderation.pdf"
      rel="noreferrer"
    >
      <UIText3 color="text-main-default">Правила модерации</UIText3>
    </a>
  );
};
